/**
 * Mobile search form (solaroutlet-v2) — instant close, no morph
 * @class SearchForm
 */
if (!customElements.get('search-form')) {
  class SearchForm extends HTMLElement {
    constructor() {
      super();

    }
    connectedCallback() {
      this.is_drawer = this.dataset.drawer;
      this.drawer = this.closest('#Search-Drawer');
      this.form = this.querySelector('form');
      this.button = document.querySelectorAll('.thb-quick-search');
      this.input = this.querySelector('.search-field');
      this.defaultTab = this.querySelector('.side-panel-content--initial');
      this.predictiveSearchResults = this.querySelector('.thb-predictive-search');
      this.cc = this.querySelector('.searchform--click-capture');
      this.isMobileInlineSearch = !!this.closest('.header-mobile-search');
      this.mobileSearchHost = this.closest('.header-mobile-search');
      this.backButton = this.querySelector('.thb-search-back');
      this.isAnimating = false;
      this.mobileMorphRect = null;
      this.scrollLockY = null;
      this.closeFallbackTimer = null;
      this.closeTransitionHandler = null;
      this.onTouchMove = this.handleTouchMove.bind(this);
      this.onVisualViewportChange = this.updateMobileSearchViewport.bind(this);
      this.viewportListening = false;
      this.hatFokus = false;

      this.moveClickCaptureToBody();
      this.setupEventListeners();
      window.addEventListener('resize', () => {
        this.popupHoeheDeckeln();
      });
    }

    /**
     * Der Abdunkler liegt im Markup innerhalb des Headers. Der Header bildet
     * fuer position:fixed einen eigenen Bezugsrahmen, dadurch waere die Flaeche
     * nur so gross wie das Suchfeld und wuerde obendrein Klicks darauf abfangen.
     * Deshalb haengt die Desktopsuche ihn einmalig direkt an den body.
     * Mobil bleibt alles, wie es ist.
     */
    moveClickCaptureToBody() {
      if (this.is_drawer || this.isMobileInlineSearch || !this.cc) {
        return;
      }
      this.cc.classList.add('searchform--click-capture--body');
      document.body.appendChild(this.cc);
    }

    setupEventListeners() {
      this.form.addEventListener('submit', this.onFormSubmit.bind(this));

      this.input.addEventListener('input', debounce((event) => {
        this.onChange(event);
      }, 300).bind(this));
      this.input.addEventListener('focus', (event) => {
        // Eigener Zustand statt document.activeElement. Waehrend des
        // focus-Ereignisses ist activeElement noch nicht zuverlaessig gesetzt,
        // dadurch fiel onChange in den Schliessen-Zweig und die Abdunklung
        // verschwand sofort wieder.
        this.hatFokus = true;
        if (this.isMobileInlineSearch && this.isMobileSearch()) {
          this.open();
        } else if (!this.is_drawer) {
          // Desktop: der Inhalt darunter wird schon beim Reinklicken abgedunkelt.
          // Das Ergebnis-Popup selbst kommt erst, wenn etwas getippt wurde,
          // sonst stuende dort ein leerer Kasten.
          document.body.classList.add('open-search');
          // Der weggefahrene Header wird zurueckgeholt, ohne Uebergang, sonst
          // bleibt die Verschiebung 300 Millisekunden bestehen und der Browser
          // scrollt weiter an der falschen Stelle nach.
          const kopfbereich = this.closest('.header-section');
          if (kopfbereich) {
            kopfbereich.style.transition = 'none';
            kopfbereich.classList.remove('header-scrolled-away');
            void kopfbereich.offsetHeight;
            window.setTimeout(() => {
              kopfbereich.style.transition = '';
            }, 60);
          }
          this.seiteFesthalten();
        }
        this.onChange(event);
      });

      this.input.addEventListener('blur', () => {
        this.hatFokus = false;
        if (!this.isMobileInlineSearch || this.is_drawer) {
          return;
        }
        // Mobile Vollbild-Suche: nicht per Blur schließen (Scrollen/Tippen in Ergebnissen
        // würde sonst die Suche in den halb-offenen Morph-Zustand zurücksetzen).
        if (this.isMobileSearch()) {
          return;
        }
        window.setTimeout(() => {
          if (!this.contains(document.activeElement)) {
            this.close();
          }
        }, 150);
      });

      this.button.forEach((item, i) => {
        item.addEventListener('click', (event) => {
          event.preventDefault();
          document.body.classList.add('open-cc');
          if (this.is_drawer) {
            this.drawer.classList.add('active');
          }
          return false;
        });
      });

      this.cc?.addEventListener('click', this.close.bind(this));

      // Verlauf loeschen. Der Knopf wird erst beim Anzeigen erzeugt, deshalb
      // ueber das Ergebnisfeld abgefangen statt direkt am Knopf.
      this.predictiveSearchResults.addEventListener('click', (event) => {
        const knopf = event.target.closest('.thb-verlauf__loeschen');
        if (!knopf) return;
        event.preventDefault();
        window.SoSuchVerlauf?.loesche();
        this.predictiveSearchResults.innerHTML = '';
        this.predictiveSearchResults.classList.remove('active');
        this.input.focus({ preventScroll: true });
      });

      // Desktop: die Lupe wird zum Kreuz, sobald die Suche offen ist.
      // Ein Klick darauf leert das Feld und schliesst das Popup, statt zu suchen.
      if (!this.is_drawer && !this.isMobileInlineSearch) {
        // Diese Instanz existiert auch auf schmalen Fenstern, dort ist sie nur
        // ausgeblendet und die mobile Vollbildsuche uebernimmt. Ohne diese
        // Pruefung wuerde der Aussenklick-Handler unten die mobile Suche beim
        // ersten Tippen wieder schliessen.
        const istDesktop = () => window.innerWidth >= 1068;

        /**
         * Der Sprung tritt nur auf, wenn der Kopfbereich gerade die Klasse
         * header-scrolled-away traegt, also per transform aus dem Bild
         * geschoben ist. Nachgemessen: Fokus in diesem Zustand springt von
         * 1800 auf 844. Ohne die Klasse springt nichts.
         *
         * Deshalb wird der Zustand aufgehoben, bevor der Fokus gesetzt wird,
         * und zwar ohne Uebergang, damit die Verschiebung sofort weg ist und
         * nicht ueber 300 Millisekunden ausklingt.
         */
        const kopfbereichEntspannen = () => {
          const sek = this.closest('.header-section');
          if (!sek) {
            return;
          }
          sek.style.transition = 'none';
          sek.classList.remove('header-scrolled-away');
          // Layout erzwingen, damit die Verschiebung wirklich weg ist,
          // bevor der Browser den Fokus verarbeitet.
          void sek.offsetHeight;
          window.setTimeout(() => {
            sek.style.transition = '';
          }, 60);
        };

        // Vor dem Fokus: pointerdown kommt vor mousedown und vor focus.
        ['pointerdown', 'mousedown'].forEach((art) => {
          this.addEventListener(art, kopfbereichEntspannen, { capture: true });
        });

        /**
         * Chrome scrollt ein Feld beim Fokussieren in den Sichtbereich und
         * rechnet dabei bei position:sticky mit der ungeklebten Position. Die
         * Seite springt dadurch weit nach oben. Nachgemessen: von 1800 auf 844.
         *
         * Gegenmittel ist, den Fokus selbst zu setzen, mit preventScroll,
         * bevor der Browser es tut. Das geht nur bei einem Zeigerereignis.
         *
         * Der Abgriff haengt am ganzen Suchformular, nicht nur am Eingabefeld.
         * Ein Klick auf das Polster der Pille, auf die Lupe oder auf den Rand
         * landet sonst am Browser vorbei und die Seite springt doch.
         */
        this.addEventListener('mousedown', (event) => {
          if (!istDesktop() || document.activeElement === this.input) {
            return;
          }
          // Der Absendeknopf behaelt sein eigenes Verhalten
          if (event.target.closest('.thb-search-submit')) {
            return;
          }
          kopfbereichEntspannen();
          event.preventDefault();
          this.input.focus({ preventScroll: true });
          this.seiteFesthalten();
        });

        // Merken, ob der Knopf wirklich mit einem Zeigergeraet gedrueckt wurde.
        // Enter im Feld erzeugt einen Klick auf den Absendeknopf, aber niemals
        // ein pointerdown. Damit ist der Unterschied eindeutig, ohne sich auf
        // Eigenschaften des Klickereignisses verlassen zu muessen.
        let zeigerAufKnopf = false;
        const submit = this.querySelector('.thb-search-submit');
        submit?.addEventListener('pointerdown', () => {
          zeigerAufKnopf = true;
        });
        window.addEventListener('pointerup', () => {
          window.setTimeout(() => {
            zeigerAufKnopf = false;
          }, 0);
        });
        submit?.addEventListener('click', (event) => {
          if (!istDesktop() || !document.body.classList.contains('open-search')) {
            return;
          }
          // Enter im Eingabefeld loest im Browser einen Klick auf den
          // Absendeknopf aus. So ein Klick kommt ohne Zeigergeraet, traegt also
          // detail 0 und die Koordinaten 0. Nur echte Mausklicks duerfen hier
          // abgefangen werden, sonst kaeme man mit Enter nie auf die
          // Suchergebnisseite.
          const echterKlick =
            zeigerAufKnopf &&
            (event.detail > 0 || event.clientX !== 0 || event.clientY !== 0);
          if (!echterKlick) {
            return;
          }
          event.preventDefault();
          this.input.value = '';
          this.close();
          this.input.blur();
        });

        // Klick irgendwo ausserhalb der Suche schliesst sie. Der Abdunkler deckt
        // den Kopfbereich bewusst nicht ab, deshalb reicht er als einziger
        // Schliessweg nicht aus.
        //
        // In der Capture-Phase, damit der erste Klick nur schliesst und nicht
        // zugleich den Link darunter ausloest. Wer auf eine abgedunkelte Seite
        // klickt, will die Suche wegklicken, nicht navigieren.
        document.addEventListener(
          'click',
          (event) => {
            if (!istDesktop() || !document.body.classList.contains('open-search')) {
              return;
            }
            if (this.contains(event.target)) {
              return;
            }
            event.preventDefault();
            event.stopPropagation();
            this.close();
          },
          true
        );
      }

      this.backButton?.addEventListener('click', (event) => {
        event.preventDefault();
        this.input.blur();
        this.close();
      });

      document.addEventListener('keyup', (e) => {
        if (e.code && e.code.toUpperCase() === 'ESCAPE') {
          this.close();
        }
      });
    }

    /**
     * Die Scrollposition laufend mitschreiben. Der Sprung beim Fokussieren
     * passiert, bevor unser focus-Handler laeuft. Dort ist window.scrollY also
     * schon der falsche Wert, wir brauchen den von davor.
     */
    /**
     * Solange die Suche offen ist, wird die Seite festgehalten.
     *
     * Hintergrund: Chrome scrollt ein fokussiertes Feld in den Sichtbereich und
     * rechnet bei position:sticky mit der ungeklebten Position. Das laesst sich
     * nur abfangen, wenn der Fokus aus einem Zeigerereignis kommt. Bei Tabulator
     * oder anderen Wegen setzt der Browser ihn selbst, da kommt kein Skript
     * davor. Deshalb wird die Position gehalten statt der Ausloeser bekaempft.
     *
     * Damit sich die Seite nicht tot anfuehlt: Mausrad oder Wischgeste
     * schliessen die Suche und geben das Scrollen sofort wieder frei.
     */
    seiteFesthalten() {
      if (this.seiteGehalten || this.is_drawer || this.isMobileInlineSearch) {
        return;
      }
      if (window.innerWidth < 1068) {
        return;
      }
      this.seiteGehalten = true;
      // Bewusst die Position von jetzt, nicht eine gemerkte von vorher. Eine
      // gemerkte Position kann veraltet sein und reisst die Seite dann irgendwo
      // hin. Die Sperre haelt nur fest, sie korrigiert nicht.
      this.gehalteneY = window.scrollY;

      this.haltePosition = () => {
        if (window.scrollY !== this.gehalteneY) {
          window.scrollTo(0, this.gehalteneY);
        }
      };
      this.scrollenGibtFrei = (event) => {
        // Rollen im Ergebnisfenster selbst schliesst nichts. Auf niedrigen
        // Fenstern rollt der Innenbereich, und dort muss man an den Inhalt
        // herankommen, ohne dass die Suche zugeht.
        const ziel = event && event.target;
        if (ziel && typeof ziel.closest === 'function' && ziel.closest('.thb-predictive-search')) {
          const innen = this.predictiveSearchResults.querySelector(
            '.side-panel-content--inner'
          );
          if (innen && innen.scrollHeight > innen.clientHeight + 1) {
            return;
          }
        }
        // Erst freigeben, dann schliessen, sonst faengt die Wache den Ruck ab
        this.seiteFreigeben();
        this.close();
      };

      window.addEventListener('scroll', this.haltePosition, { passive: true });
      window.addEventListener('wheel', this.scrollenGibtFrei, { passive: true, capture: true });
      window.addEventListener('touchmove', this.scrollenGibtFrei, { passive: true, capture: true });
    }

    /**
     * Deckelt das Ergebnisfenster auf den Platz, der bis zum unteren Bildrand
     * bleibt. Aus CSS ist die Oberkante nicht zuverlaessig zu bekommen, die
     * Themevariablen fuer Kopfhoehe und Versatz beschreiben eine andere
     * Strecke und deckeln dadurch rund siebzig Pixel zu frueh.
     */
    popupHoeheDeckeln() {
      if (this.is_drawer || this.isMobileInlineSearch || window.innerWidth < 1068) {
        return;
      }
      const feld = this.predictiveSearchResults;
      if (!feld || feld.hasAttribute('inert')) {
        return;
      }
      feld.style.setProperty('--ps-maxhoehe', 'none');
      const oben = feld.getBoundingClientRect().top;
      const platz = Math.max(200, Math.round(window.innerHeight - oben - 16));
      feld.style.setProperty('--ps-maxhoehe', platz + 'px');
    }

    seiteFreigeben() {
      if (!this.seiteGehalten) {
        return;
      }
      this.seiteGehalten = false;
      window.removeEventListener('scroll', this.haltePosition);
      window.removeEventListener('wheel', this.scrollenGibtFrei, { capture: true });
      window.removeEventListener('touchmove', this.scrollenGibtFrei, { capture: true });
    }

    getQuery() {
      return this.input.value.trim();
    }

    onChange() {
      const searchTerm = this.getQuery();

      if (!searchTerm.length) {
        if (!this.is_drawer) {
          if (this.isMobileInlineSearch && this.isMobileSearch() && document.activeElement === this.input) {
            if (!this.zeigeVerlauf()) {
              this.predictiveSearchResults.setAttribute('inert', '');
            }
            return;
          }
          // Desktop: solange das Feld den Fokus hat, bleibt der Inhalt abgedunkelt.
          // Ohne Verlauf verschwindet das Popup, wenn der Suchbegriff geleert
          // wird; mit Verlauf tritt dieser an seine Stelle.
          if (!this.isMobileInlineSearch && this.hatFokus) {
            if (!this.zeigeVerlauf()) {
              this.predictiveSearchResults.setAttribute('inert', '');
              this.predictiveSearchResults.classList.remove('active');
            }
            document.body.classList.add('open-search');
            return;
          }
          this.close();
        }
        return;
      }
      if (!this.is_drawer) {
        this.open();
        this.seiteFesthalten();
      }
      this.predictiveSearchResults.classList.add('active');
      this.getSearchResults(searchTerm);
    }

    onFormSubmit(event) {
      if (!this.getQuery().length) {
        event.preventDefault();
      }
    }

    onFocus() {
      const searchTerm = this.getQuery();

      if (!searchTerm.length) {
        if (!this.zeigeVerlauf()) {
          this.predictiveSearchResults.innerHTML = '';
        }
        return;
      }

      this.getSearchResults(searchTerm);
    }

    /**
     * Zeigt bei leerem Suchfeld die zuletzt angesehenen Produkte und die
     * zuletzt gesuchten Begriffe. Gibt false zurueck, wenn nichts gespeichert
     * ist; dann bleibt das Verhalten wie vorher, also kein leerer Kasten.
     */
    zeigeVerlauf() {
      const verlauf = window.SoSuchVerlauf;
      if (!verlauf || !verlauf.hatEintraege()) {
        return false;
      }
      // Der Rahmen steht ohne Warten, damit das Popup im selben Moment
      // aufgeht, in dem jemand in die Suche klickt.
      const markup = verlauf.rahmen();
      if (!markup) {
        return false;
      }
      this.predictiveSearchResults.innerHTML = markup;
      this.predictiveSearchResults.removeAttribute('inert');
      this.predictiveSearchResults.classList.add('active');
      this.predictiveSearchResults.classList.remove('loading');
      document.body.classList.add('open-search');
      this.popupHoeheDeckeln();

      // Die Produktkarten muessen geholt werden und kommen nach. Wurde
      // inzwischen getippt, gilt das Ergebnis der Eingabe, nicht der Verlauf.
      verlauf.fuelleProdukte(this.predictiveSearchResults).then(() => {
        if (this.getQuery().length) {
          return;
        }
        this.popupHoeheDeckeln();
      });
      return true;
    }

    getSearchResults(searchTerm) {

      this.predictiveSearchResults.classList.add('loading');

      fetch(`${theme.routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&${encodeURIComponent('resources[type]')}=product,article,query,page&${encodeURIComponent('resources[limit]')}=10&${encodeURIComponent('resources[limit_scope]')}=each&section_id=predictive-search`)
        .then((response) => {
          this.predictiveSearchResults.classList.remove('loading');
          if (!response.ok) {
            var error = new Error(response.status);
            throw error;
          }

          return response.text();
        })
        .then((text) => {
          const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;

          this.renderSearchResults(resultsMarkup);
        })
        .catch((error) => {
          throw error;
        });
    }

    renderSearchResults(resultsMarkup) {
      this.predictiveSearchResults.innerHTML = resultsMarkup;
      this.popupHoeheDeckeln();
      // Mobil die Hoehe neu vermessen. Beim Oeffnen steht das Layout noch nicht
      // endgueltig, dadurch war die Suche zu hoch und der Knopf Alle Ergebnisse
      // anzeigen ragte unter den Bildrand.
      if (this.isMobileInlineSearch && this.isMobileSearch()) {
        this.updateMobileSearchViewport();
      }
      const submitBtn = this.predictiveSearchResults.querySelector('#search-results-submit');
      if (!submitBtn) {
        return;
      }

      if (this.isMobileInlineSearch && this.isMobileSearch()) {
        submitBtn.classList.add('button', 'accent', 'full', 'search-results-submit--mobile');
        submitBtn.type = 'button';
      } else if (!this.is_drawer) {
        submitBtn.classList.remove('button');
      }

      /**
       * Mobil reagiert der Knopf schon auf den Fingerdruck.
       *
       * Grund: Beim Antippen verliert das Eingabefeld den Fokus, die Tastatur
       * klappt ein und die Suche waechst auf die volle Hoehe. Dabei rutscht der
       * Knopf nach unten weg. Der Klick, der erst beim Loslassen entsteht,
       * landet dann nicht mehr auf dem Knopf, und man muss ein zweites Mal
       * tippen. Auf dem Fingerdruck ist das Layout noch unveraendert.
       */
      let abgeschickt = false;
      const abschicken = (event) => {
        if (abgeschickt) {
          return;
        }
        abgeschickt = true;
        event.preventDefault();
        this.submitSearch();
      };

      if (this.isMobileInlineSearch && this.isMobileSearch()) {
        submitBtn.addEventListener('pointerdown', abschicken);
      }
      submitBtn.addEventListener('click', abschicken);
    }
    submitSearch() {
      const query = this.getQuery();
      if (!query.length) {
        return;
      }

      const action = this.form.getAttribute('action') || '/search';
      const url = new URL(action, window.location.origin);
      url.searchParams.set('q', query);
      window.location.assign(url.toString());
    }

    close() {
      if (
        this.isMobileInlineSearch &&
        this.isMobileSearch() &&
        document.body.classList.contains('open-search') &&
        !this.isAnimating
      ) {
        this.closeMobileFullscreen();
        return;
      }
      this.finishClose();
    }
    open() {
      if (this.isMobileInlineSearch && this.isMobileSearch()) {
        this.openMobileFullscreen();
        return;
      }
      document.body.classList.add('open-search');
      this.predictiveSearchResults.removeAttribute('inert');
    }
    openMobileFullscreen() {
      this.cancelPendingClose();
      this.updateMobileSearchViewport();
      this.clearMorphVars();

      if (this.mobileSearchHost) {
        this.mobileSearchHost.style.minHeight = '';
      }

      document.body.classList.add('open-search', 'open-search--expanded');
      this.predictiveSearchResults.removeAttribute('inert');
      this.lockBodyScroll();
      this.enableMobileScrollGuard();
      this.enableVisualViewportListener();
    }
    closeMobileFullscreen() {
      this.finishClose();
    }
    cancelPendingClose() {
      if (this.closeTransitionHandler) {
        this.removeEventListener('transitionend', this.closeTransitionHandler);
        this.closeTransitionHandler = null;
      }
      if (this.closeFallbackTimer) {
        clearTimeout(this.closeFallbackTimer);
        this.closeFallbackTimer = null;
      }
      this.isAnimating = false;
    }
    applyMorphVars(rect) {
      const root = document.documentElement;
      root.style.setProperty('--search-morph-top', rect.top + 'px');
      root.style.setProperty('--search-morph-left', rect.left + 'px');
      root.style.setProperty('--search-morph-width', rect.width + 'px');
      root.style.setProperty('--search-morph-height', rect.height + 'px');
      root.style.setProperty('--search-morph-radius', rect.radius || '6px');
    }
    clearMorphVars() {
      const root = document.documentElement;
      root.style.removeProperty('--search-morph-top');
      root.style.removeProperty('--search-morph-left');
      root.style.removeProperty('--search-morph-width');
      root.style.removeProperty('--search-morph-height');
      root.style.removeProperty('--search-morph-radius');
    }
    finishClose() {
      this.seiteFreigeben();
      this.cancelPendingClose();
      this.mobileMorphRect = null;
      this.disableMobileScrollGuard();
      this.disableVisualViewportListener();
      this.unlockBodyScroll();
      this.predictiveSearchResults.setAttribute('inert', '');
      document.body.classList.remove('open-search', 'open-search--expanded', 'open-search--keyboard-open');
      document.documentElement.style.removeProperty('--mobile-search-top');
      document.documentElement.style.removeProperty('--mobile-search-height');
      this.clearMorphVars();
      if (this.mobileSearchHost) {
        this.mobileSearchHost.style.minHeight = '';
      }
    }
    lockBodyScroll() {
      if (!this.isMobileInlineSearch || !this.isMobileSearch() || this.scrollLockY != null) {
        return;
      }
      this.scrollLockY = window.scrollY || window.pageYOffset || 0;
      document.documentElement.style.overflow = 'hidden';
      document.body.style.overflow = 'hidden';
      // Kein position:fixed auf Mobile — das blockiert Scrollen in der Ergebnisliste (iOS).
    }
    unlockBodyScroll() {
      if (this.scrollLockY == null) {
        return;
      }
      const scrollY = this.scrollLockY;
      document.documentElement.style.overflow = '';
      document.body.style.overflow = '';
      window.scrollTo(0, scrollY);
      this.scrollLockY = null;
    }
    enableMobileScrollGuard() {
      if (!this.isMobileInlineSearch || !this.isMobileSearch()) {
        return;
      }
      document.addEventListener('touchmove', this.onTouchMove, { passive: false });
    }
    disableMobileScrollGuard() {
      document.removeEventListener('touchmove', this.onTouchMove, { passive: false });
    }
    handleTouchMove(event) {
      if (!document.body.classList.contains('open-search--expanded')) {
        return;
      }

      const scrollArea = this.querySelector('.thb-predictive-search .side-panel-content--inner');
      if (!scrollArea) {
        return;
      }

      const path = event.composedPath?.() || [];
      const touchNode = path[0] || event.target;

      if (
        scrollArea === touchNode ||
        scrollArea.contains(touchNode) ||
        path.includes(scrollArea)
      ) {
        return;
      }

      const scrollHost = scrollArea.closest('scroll-shadow');
      if (scrollHost && (scrollHost === touchNode || scrollHost.contains(touchNode) || path.includes(scrollHost))) {
        return;
      }

      event.preventDefault();
    }
    isMobileSearch() {
      return window.matchMedia('(max-width: 1067px)').matches;
    }
    updateMobileSearchOffset() {
      this.updateMobileSearchViewport();
    }
    updateMobileSearchViewport() {
      if (!this.isMobileInlineSearch || !this.isMobileSearch()) {
        return;
      }

      const announcement = document.querySelector('.announcement-bar-section');
      const announcementBottom = announcement
        ? Math.max(0, Math.round(announcement.getBoundingClientRect().bottom))
        : 0;

      document.documentElement.style.setProperty('--mobile-search-top', announcementBottom + 'px');

      if (!document.body.classList.contains('open-search--expanded')) {
        document.documentElement.style.removeProperty('--mobile-search-height');
        return;
      }

      this.clearMorphVars();
      if (this.mobileSearchHost) {
        this.mobileSearchHost.style.minHeight = '';
      }

      // Tastatur zu: volle Höhe. Tastatur offen: sichtbarer Bereich (visualViewport).
      const vv = window.visualViewport;
      const layoutHeight = window.innerHeight;
      const visibleBottom = vv
        ? Math.round(vv.offsetTop + vv.height)
        : layoutHeight;
      const keyboardOpen = layoutHeight - visibleBottom > 80;
      // Der kleinere der beiden Werte. visualViewport meldet je nach Browser
      // mehr als das Fenster hoch ist, dann waechst die Suche unten heraus.
      // Bei offener Tastatur ist visualViewport der kleinere und damit richtig.
      const sichtbareHoehe = Math.min(visibleBottom, layoutHeight);
      // Aus der tatsaechlichen Oberkante rechnen, nicht aus der Unterkante der
      // Ankuendigungsleiste. Die beiden weichen voneinander ab, und dann steht
      // die Suche unten ueber dem Bildrand hinaus.
      const obenJetzt = Math.round(this.getBoundingClientRect().top);
      const bezug = obenJetzt > 0 && obenJetzt < sichtbareHoehe ? obenJetzt : announcementBottom;
      const searchHeight = Math.max(0, sichtbareHoehe - bezug);

      // Die Hoehe wird immer gesetzt, nicht nur bei offener Tastatur. 100dvh
      // liefert je nach Browser einen groesseren Wert als der wirklich
      // sichtbare Bereich, dadurch waechst die Suche unten aus dem Bild und
      // der Knopf Alle Ergebnisse anzeigen wird angeschnitten.
      document.documentElement.style.setProperty('--mobile-search-height', searchHeight + 'px');

      if (keyboardOpen) {
        document.body.classList.add('open-search--keyboard-open');
      } else {
        document.body.classList.remove('open-search--keyboard-open');
      }
    }
    enableVisualViewportListener() {
      if (this.viewportListening || !this.isMobileInlineSearch || !this.isMobileSearch()) {
        return;
      }
      this.viewportListening = true;
      this.updateMobileSearchViewport();
      if (window.visualViewport) {
        window.visualViewport.addEventListener('resize', this.onVisualViewportChange);
        window.visualViewport.addEventListener('scroll', this.onVisualViewportChange);
      }
      window.addEventListener('resize', this.onVisualViewportChange);
    }
    disableVisualViewportListener() {
      if (!this.viewportListening) {
        return;
      }
      this.viewportListening = false;
      if (window.visualViewport) {
        window.visualViewport.removeEventListener('resize', this.onVisualViewportChange);
        window.visualViewport.removeEventListener('scroll', this.onVisualViewportChange);
      }
      window.removeEventListener('resize', this.onVisualViewportChange);
    }
  }
  customElements.define('search-form', SearchForm);
}